eventsHandler = {
    $iconClose: $('.tribe-events-calendar-month-mobile-events__day-marker').find('.icon-close'),
    $tribeContainer: $('.tribe-common-l-container'),
    $tooltipstered: $('.tooltipstered'),

    moreEvents: function(){
        var self = this;
        $(document).on('click', 'a[href*="#more-event"]', function(){
            var page = $(this).data('read-page');
            $(this).parent().addClass('hide');
            self.$tribeContainer = $(document).find('.tribe-common-l-container');
            self.$tribeContainer.find('.tribe-events-calendar-list__event-row[data-page='+page+']').removeClass('hide');
            self.$tribeContainer.find('.read-more[data-read-page='+(page+1)+']').parent().removeClass('hide');  
        })
    },

    init: function(){
        var self = this;
        
        self.moreEvents();
        self.$iconClose.on('click', function(){
            var $parent = $(this).closest('.tribe-events-calendar-month-mobile-events__mobile-day');
            $parent.removeClass('tribe-events-calendar-month-mobile-events__mobile-day--show');
            $parent.css({
                'display': 'none'
            })
            self.$tribeContainer.find('.tribe-events-calendar-month__day-cell--selected').removeClass('tribe-events-calendar-month__day-cell--selected');
        })

        $(document).on('mouseover', '.tooltipstered', function(){
            var url = $(this).data('url');

            if (url) {
                setTimeout(() => {
                    $(document).find('.tooltipster-base').wrap('<a href="'+url+'" target="_blank"></a>');
                }, 500);
            }
        });


    }
}